import { configManagerCloudServicesApi as api } from '../configManagerCloudServicesApi';
import {
  ListProductCatalogConfigManagerCloudServicesApiV1ProductCatalogGetApiArg,
  ListProductCatalogConfigManagerCloudServicesApiV1ProductCatalogGetApiResponse,
  AddProductToCatalogConfigManagerCloudServicesApiV1ProductCatalogPostApiResponse,
  AddProductToCatalogConfigManagerCloudServicesApiV1ProductCatalogPostApiArg,
} from './types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    listProductCatalogConfigManagerCloudServicesApiV1ProductCatalogGet: build.query<
      ListProductCatalogConfigManagerCloudServicesApiV1ProductCatalogGetApiResponse,
      ListProductCatalogConfigManagerCloudServicesApiV1ProductCatalogGetApiArg
    >({
      query: () => ({ url: `/config-manager-cloud-services/api/v1/product-catalog/` }),
    }),
    addProductToCatalogConfigManagerCloudServicesApiV1ProductCatalogPost: build.mutation<
      AddProductToCatalogConfigManagerCloudServicesApiV1ProductCatalogPostApiResponse,
      AddProductToCatalogConfigManagerCloudServicesApiV1ProductCatalogPostApiArg
    >({
      query: queryArg => ({
        url: `/config-manager-cloud-services/api/v1/product-catalog/`,
        method: 'POST',
        body: queryArg.productCatalogBase,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as ProductCatalogApi };

export const {
  useAddProductToCatalogConfigManagerCloudServicesApiV1ProductCatalogPostMutation,
  useListProductCatalogConfigManagerCloudServicesApiV1ProductCatalogGetQuery,
} = injectedRtkApi;
